import React from "react";
import { CtaButton } from "../Cta/cta-button";
import { onClickType } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";

type SignInTryItFreeWrapperType = {
  className?: string;
  onClickHandler: onClickType;
};

const SignInTryItFreeWrapper: React.FC<SignInTryItFreeWrapperType> = ({
  onClickHandler,
}) => {
  return (
    <div
      data-testid="signIn-tryItFree-wrapper"
      className="flex items-center gap-6"
    >
      <CtaButton
        variant="tertiaryForest"
        link={null}
        linkUrl={"https://secure.simplepractice.com/users/sign_in"}
        copy="Sign in"
        copySize="bodyRegular"
        hasAnimation={true}
        onClick={e => onClickHandler(e, { category: "sign in" })}
      />
      <CtaButton
        variant="primarySun"
        link={"/sign-up/"}
        copy="Start free trial"
        copySize="bodySmall"
        onClick={e =>
          onClickHandler(
            e,
            { object: "Marketing CTA" },
            "Marketing CTA Clicked"
          )
        }
      />
    </div>
  );
};

export default SignInTryItFreeWrapper;
